import type { GatsbyBrowser } from "gatsby";

import { pushRouteChangeEvent } from "@/utils/googleTagManager";

import "@/styles/global.css";

export const onRouteUpdate: NonNullable<GatsbyBrowser["onRouteUpdate"]> = () => {
  pushRouteChangeEvent();
};
